export const NO_NAME_EXP = 'no_name_experiment'
